export default __webpack_public_path__ + "static/media/boy-on-rocket.57928d81.png";